import { createUiKit } from '@barbanet/ui-kit'

import '@barbanet/ui-kit/styles'

export default createUiKit({
	theme: {
		default: {
			name: 'admin'
		}
	},
	layout: {
		defaultLayout: 'panel'
	},
	defaults: {
		BSnackbar: {
			position: 'bottom-end',
			closable: true
		},
		BInput: {
			clearable: true
		},
		BCurrencyInput: {
			clearable: true
		},
		BDateTimePicker: {
			clearable: true
		},
		BDropdown: {
			clearable: true
		},
		BFileInput: {
			clearable: true
		}
	}
})
